<h2 mat-dialog-title>Choices</h2>
<mat-dialog-content>
  <mat-table #table [dataSource]="dataSource" id="tblChoices" cdkDropList (cdkDropListDropped)="rowDrop($event)"
    [cdkDropListData]="dataSource.data">
    <ng-container matColumnDef="DragHandle">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element" style="cursor: move;">
        <img alt="Re-Order" title="Re-Order" src="./assets/images/grip.png" style="width: 10px">
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Choice">
      <mat-header-cell *matHeaderCellDef> Choice </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        <tyl-form-field label='' [fullWidth]='true'>
          <input matInput id='inpChoice{{i}}' type='text' [disabled]="dbField" [(ngModel)]='element.CodeDescription'
            (click)="focusControl(i)" />
        </tyl-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Default">
      <mat-header-cell *matHeaderCellDef> Default </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-radio-button [checked]="defaultId == element.Id" (click)="!noDefault && defaultClick(element)"
          class="eFormChoicRadio" [disabled]="noDefault">
        </mat-radio-button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="IsCritical">
      <mat-header-cell *matHeaderCellDef> Critical Condition if Selected </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <tyl-checkbox [id]='"chkIsCritical_" + element.CodeDescription' [name]='"chkIsCritical_" + element.CodeDescription' [(checked)]='element.IsCritical'></tyl-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Actions">
      <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = dataIndex;">
        <a class="link" (click)="deleteClick(element)">Delete</a>
      </mat-cell>
    </ng-container>



    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblChoicesDataRow{{i}}" cdkDrag
      [cdkDragData]="row" style="padding:0px;overflow: hidden;" matRipple>
    </mat-row>
  </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
    <tyl-button image="add.png" label="Add Choice" [disabled]="dbField" disabledImage="add disabled.png"
      (clickEvent)="addClick()"></tyl-button>

    <tyl-button image="import.png" *ngIf="!dbField" label="Display Merge Fields"
      (clickEvent)="displayMergeFields()"></tyl-button>
  </div>
  <div class='flex-footer-middle'>
    <tyl-checkbox *ngIf="showNoDefaultCheckbox" id='chkNoDefault' name='chkNoDefault' [(checked)]='noDefault'
      (change)="noDefaultChange()">No default</tyl-checkbox>
  </div>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>